import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import type { RootState } from "store";

import { setGeoCords, setState, setCity, setCountry } from "store/actions";
import { getLocation } from "./utils/getLocation";

const useUserLocation = (): void => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    if (user) {
      const geo = navigator.geolocation;
      geo.getCurrentPosition(async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        console.log(`lat`, lat);
        console.log(`long`, lng);
        dispatch(setGeoCords({ lng, lat }));
        try {
          const { city, state, country } = await getLocation(lat, lng);
          dispatch(setCity(city));
          dispatch(setState(state));
          dispatch(setCountry(country));
        } catch (err) {
          console.log("Error setting geolocation", err);
        }
      });
    }
  }, [user]);
};

export default useUserLocation;
